import { render, staticRenderFns } from "./DashboardPadrao.vue?vue&type=template&id=72317c5c&"
import script from "./DashboardPadrao.vue?vue&type=script&lang=js&"
export * from "./DashboardPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports